import React, { Component } from 'react';
import './SocialList.css';
import {
  TelegramShareButton,
  VKShareButton,
  OKShareButton,
} from 'react-share';
import exampleImage from '../Menu/imgs/r-telecom_logo.png';
import { HOST } from '../../constants/Fetch';

const SocialItem = item => (
  <a href={item.link} target="_blank" className={`socialList__item socialList__item--${item.social}`}>{item.social}</a>
);

class SocialList extends Component {
  render() {
    const shareUrl =  this.props.url;
    const title = this.props.title || 'Работа в ЭР-Телеком Холдинг';
    return (
      <div className={`socialList ${this.props.modifier ? this.props.modifier  : ''}`}>
        {
          // this.props.socials ?
          // this.props.socials.map((item, index) => (
          //   <SocialItem {...item} key={`socialItem-${index}`} />
          // )) :
              <React.Fragment>
                <SocialItem
                    link={"https://t.me/erstart"}
                    // className="socialList__item socialList__item--telegram"
                    social={"telegram"}
                />
                <SocialItem
                    link={"https://vk.com/start.rabotaertelecom"}
                    // className="socialList__item socialList__item--vkontakte"
                    social={"vkontakte"}
                />
                <SocialItem
                    link={"https://max.ru/id5902202276_biz"}
                    // className="socialList__item socialList__item--max"
                    social={"max"}
                />
              </React.Fragment>
        }
      </div>
    );
  }
}

export default SocialList;



// WEBPACK FOOTER //
// ./src/components/SocialList/index.js